/* eslint-disable no-console */
import React, { useState } from 'react';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';

const FileUpload = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleUpload = async () => {
    // debugger;
    if (files.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select files to upload',
      });
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('FileDetails', file);
      });

      const response = await axios.post(
        `${variables.BASE_URL}InboundFileUpload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const apiData = response.data;
      if (apiData?.IsSuccess !== false && apiData?.IsAuthorize !== false) {
        setFiles([]);
        document.getElementById('fileInput').value = '';
      } else if (apiData?.IsSuccess !== true) {
        setFiles([]);
        document.getElementById('fileInput').value = '';
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: apiData.Reason,
        });
      } else if (apiData?.IsAuthorize !== true) {
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      }

    //   console.log('Files uploaded successfully:', apiData);
      // You can handle the response here
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    //   console.error('Error uploading files:', error);
      // You can handle errors here
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      {/* <div
        className={
              activeMenu
                ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
                : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
            }
      > */}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          style={{ background: 'linear-gradient(to right, #060047 , #00FFFF  )', borderRadius: '10px' }}
        >
          <Navbar />
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div>
              <label htmlFor="fileInput" className="custom-file-upload">
                <CloudUploadIcon style={{ marginRight: '8px' }} />
                <input type="file" id="fileInput" onChange={handleFileChange} multiple accept=".txt,.csv" />
              </label>
              <Button variant="contained" color="primary" onClick={handleUpload} disabled={loading}>
                {loading ? 'Uploading...' : 'Submit'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
